import React from 'react';
import Grid from '@material-ui/core/Grid';

import Product from './product/Product';
import useStyles from './style';
import Navbar1 from '../Navbar/Navbarlocal';

const Products = ({products,addToCart,totalitems,setUser}) => {
  const classes = useStyles();
  return (
    <main className={classes.content}>
      <div className={classes.toolbar} />
      <Grid container justify="center" spacing={4}>
        {products.map((product) => (
          <Grid key={product.id} item xs={12} sm={6} md={4} lg={3}>
            <Product key={product.id} product={product} addToCart={addToCart}/>
          </Grid>
        ))}
      </Grid>
    </main>
  );
};

export default Products;